import React from "react";
import { useWindowDimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import TabViewHeaderView from "./TabViewHeaderView";

import { useTheme } from "@/providers/ThemeProvider";

/** Width threshold below which compact layout is applied */
const COMPACT_WIDTH_THRESHOLD = 400;

/**
 * Props for the TabViewHeaderContainer component
 */
interface IProps {
  title: string;
}

/**
 * Container component for tab view header with theme support.
 * Applies compact spacing on small phone screens to reduce visual bloat.
 * @param root0 - Component props
 * @param root0.title - Title text to display in the header
 */
const TabViewHeaderContainer = ({ title }: IProps) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const insets = useSafeAreaInsets();
  const paddingTop = insets.top;
  const { width } = useWindowDimensions();
  const isCompact = width < COMPACT_WIDTH_THRESHOLD;

  return (
    <TabViewHeaderView
      paddingTop={paddingTop}
      title={title}
      isDark={isDark}
      isCompact={isCompact}
    />
  );
};

export default TabViewHeaderContainer;
